module.exports = __webpack_public_path__ + "files/41771c6363d081f29ec45014788bfbd7.png";